export interface TopperSection {
  sectionId: number;
  displayType: number;
  name: string;
  items: TopperItem[];
}

export interface TopperItem {
  image: string;
  url: string;
  itemId?: number; // TODO: The MultiSelect toppers data currently does not include an exposed itemId. We will need to make this data available from the backend, after which we can remove the optional designation.
  name: string;
  description: string;
  itemIndex?: number;
}

export const DisplayType = {
  ImageTitleAndDescription: 1,
  // ImageTitleAndDescription is also used for 2
  ImageAndTooltip: 3,
  ImageAndTitle: 4,
};
